/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notfound_Actions_Go_HomeInputs */



/**
* | output |
* | --- |
* | "Go Home" |
*
* @param {Notfound_Actions_Go_HomeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const notfound_actions_go_home = /** @type {((inputs?: Notfound_Actions_Go_HomeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notfound_Actions_Go_HomeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zur Startseite")
	return /** @type {LocalizedString} */ ("Go Home")
});